<template>
  <div class="not-found-container">
    <!-- 漂浮粒子背景 -->
    <div class="particles">
      <div class="particle" v-for="i in 20" :key="i" :style="{
        left: `${Math.random() * 100}vw`,
        top: `${Math.random() * 100}vh`,
        width: `${Math.random() * 10 + 5}px`,
        height: `${Math.random() * 10 + 5}px`,
        animationDelay: `${Math.random() * 5}s`,
        animationDuration: `${Math.random() * 10 + 10}s`
      }"></div>
    </div>

    <!-- 核心内容区 -->
    <div class="not-found-card">
      <!-- 动态404数字 -->
      <div class="error-number">
        <span class="num num-4">4</span>
        <span class="num num-0">0</span>
        <span class="num num-4">4</span>
      </div>

      <!-- 提示文案 -->
      <div class="error-desc">
        <h3>页面走丢了 😵</h3>
        <p>抱歉，您访问的页面不存在、已删除或路径错误</p>
      </div>

      <!-- 操作按钮组 -->
      <div class="error-actions">
        <el-button
          type="primary"
          size="large"
          @click="goBackHome"
          icon="House"
          class="btn-home"
        >
          返回首页
        </el-button>
        <el-button
          type="default"
          size="large"
          @click="goBack"
          icon="ArrowLeft"
          class="btn-back"
        >
          返回上一页
        </el-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';

const router = useRouter();

// 返回首页
const goBackHome = () => {
  router.push('/index/home');
};

// 返回上一页（兼容无历史记录的情况）
const goBack = () => {
  if (window.history.length > 1) {
    router.go(-1);
  } else {
    goBackHome();
  }
};
</script>

<style scoped>
/* 全局容器 - 渐变背景 + 全屏布局 */
.not-found-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f0f8fb 0%, #e8f4f8 100%);
  position: relative;
  overflow: hidden;
}

/* 漂浮粒子动画 */
.particles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.particle {
  position: absolute;
  border-radius: 50%;
  background: rgba(64, 158, 255, 0.1);
  animation: float linear infinite;
}

@keyframes float {
  0% {
    transform: translateY(100vh) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: translateY(-10vh) rotate(360deg);
    opacity: 0;
  }
}

/* 卡片容器 - 毛玻璃效果 + 阴影 */
.not-found-card {
  text-align: center;
  padding: 60px 80px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.9);
  position: relative;
  z-index: 1;
  transform: translateY(-150px); /* 核心：往上移50px，数值越大移得越多 */
}

/* 404数字 - 渐变 + 呼吸动画 */
.error-number {
  font-size: 120px;
  font-weight: 800;
  margin-bottom: 20px;
  position: relative;
}

.num {
  background: linear-gradient(135deg, #409eff, #67c23a);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  display: inline-block;
  animation: breathe 3s ease-in-out infinite;
}

.num-0 {
  animation-delay: 0.5s;
}

.num-4:last-child {
  animation-delay: 1s;
}

@keyframes breathe {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

/* 提示文案 - 层级排版 */
.error-desc h3 {
  font-size: 24px;
  color: #303133;
  margin-bottom: 12px;
  font-weight: 600;
}

.error-desc p {
  font-size: 16px;
  color: #606266;
  margin-bottom: 40px;
  line-height: 1.6;
}

/* 按钮组 - 间距 + hover效果 */
.error-actions {
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
}

.btn-home {
  background: linear-gradient(135deg, #409eff, #36cfc9);
  border: none;
  padding: 12px 32px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.btn-home:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

.btn-back {
  padding: 12px 32px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.btn-back:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(99, 102, 105, 0.2);
}

/* 响应式适配 - 移动端优化 */
@media (max-width: 768px) {
  .not-found-card {
    padding: 40px 30px;
    margin: 0 20px;
  }

  .error-number {
    font-size: 80px;
  }

  .error-desc h3 {
    font-size: 20px;
  }

  .error-desc p {
    font-size: 14px;
  }

  .error-actions {
    flex-direction: column;
    gap: 15px;
  }

  .btn-home, .btn-back {
    width: 100%;
  }
}
</style>